import React, { useState, useEffect} from 'react';
import LayoutNavSectionList from 'components/layout_and_quote_builder/LayoutNavSectionList.jsx';
import LayoutContext from 'components/contexts/LayoutContext.jsx';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx';
import { CacheProvider } from 'components/layout_and_quote_builder/quote_builder/CacheContext.jsx';
import ErrorBoundary from 'components/common/ErrorBoundary.jsx';

const ShowLayoutAndQuoteBuilderPage = ( {config, navSections, dimensionGroups, layoutOptions, formulaOptions, optionsUserEntered, unit, locale, theme, btn_action, dimension_texts_on_layouts_enabled, user_quote_id} ) => {
  const LayoutContextValues = {
    dimensionGroups: dimensionGroups,
    layoutOptions: layoutOptions,
    formulaOptions: formulaOptions,
    optionsUserEntered: optionsUserEntered,
    unit: unit,
    locale: locale,
    theme: theme,
    btn_action: btn_action,
    dimension_texts_on_layouts_enabled: dimension_texts_on_layouts_enabled,
  }

  const [count, setCount] = useState(1000);

  // The Manage section (customer details, windows, currency, dimensions, status) was dropped from the
  // machine-cost flow; only "Quantity in order" remains, because it drives the manufacturing line search.
  // It is rendered through the SAME general form, filtered to just the count field (and its hidden
  // updated_at), so the input keeps publishing quote_builder.count_changed and persisting on blur via
  // post_on_change -- currency/windows had their own endpoints, so dropping their inputs does not affect
  // how the count saves.
  const quantityOnlyGeneralConfig = {
    ...config.general,
    attributes: config.general.attributes.filter(
      (attribute) => attribute.name === 'count' || attribute.name === 'updated_at'
    )
  };

  useEffect( () => {
    window.user_quote_id = user_quote_id
  }, [])

  MyEventListener([
    {
      key: 'quote_builder.count_changed',
      callback: (msg) => {  setCount( () => msg.detail ) }
    }
  ])

  return (
    <ErrorBoundary
      componentName="ShowLayoutAndQuoteBuilderPage"
      errorContext={{ user_quote_id: user_quote_id }}
    >
      <CacheProvider initialCache={window.user_quote_section_properties_cached}>
        <LayoutContext.Provider value={LayoutContextValues} >

            <div className={`${styles.component_container} container`} >

              {/* Push the quantity form to the far right of the page; the inner block shrinks to its content
                  so the label and input columns size to fit and sit right next to each other (a full-width
                  row would push them to opposite edges). */}
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <div style={{ display: 'inline-block' }}>
                  <QuoteBuilderForm config={quantityOnlyGeneralConfig} readOnly={window.user_quote_finalised} />
                </div>
              </div>

              <table className="table table-no-border sectionTable">
                <tbody>
                  <tr style={{ backgroundColor: '#ddd' }}>
                    <td colSpan="2" style={{ textAlign: 'right'  }}> <h3  style={{ marginRight: "10px" }}>  {t('quote_builder.sections')} </h3> </td>
                  </tr>

                  <tr>
                    <td colSpan="2">
                      <LayoutNavSectionList navSections={navSections} count={count} config={config} /> <br /> <br />
                    </td>
                  </tr>

                </tbody>
              </table>
            </div>


        </LayoutContext.Provider>
      </CacheProvider>
    </ErrorBoundary>
  )
};

export default ShowLayoutAndQuoteBuilderPage;
